<template>
  <div>
    <span :class="`badge badge-${salaryRateClasses[rate ?? 0]}`">{{ salaryRateTitle[(rate ?? 0)] }}</span>
  </div>
</template>

<script>

export default {
  props: ['rate'],
  data() {
    return {
      salaryRateClasses: {
        0: 'empty',
        1: 'success',
        2: 'warning',
        3: 'info',
      },
      salaryRateTitle: {...this.$platformConstants.salaryRates},
    }
  }
}

</script>

<style scoped>
.badge-empty {
  border: 1px solid lightgray;
}
</style>
